

const ReportGeneration = () => {
  return (
    <div>ReportGeneration</div>
  )
}

export default ReportGeneration